import { laborHoursConstant } from 'src/redux/actions/constant';

const intitialstate: object = {
  response: null,
  loading: false,
};

export const getBuildingsOverviewReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case laborHoursConstant.GET_BUILDINGS_OVERVIEW_SUCCESS: {
      return {
        ...state,
        response: action.payload?.data,
        loading: false,
      };
    }

    case laborHoursConstant.GET_BUILDINGS_OVERVIEW_FAILURE:
      return {
        ...state,
        response: null,
        loading: false,
      };

    case laborHoursConstant.GET_BUILDINGS_OVERVIEW_LOADER:
      return {
        ...state,
        loading: true,
      };

    case laborHoursConstant.GET_BUILDINGS_OVERVIEW_RESET:
      return intitialstate;

    default:
      return state;
  }
};
